/**
 * Created by Pankaj on 29-nov-2019
 */

import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {RomanEmpireParsedInitData} from "../../server/data/RomanEmpireParsedInitData";
import {GuiDefaults} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaults";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Utils} from "../../Utils/Utils";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {RomanEmpireGameModuleConfig} from "../../RomanEmpireGameModuleConfig";

export class REGenieReSpinOutroView extends ScreenView {
    private _youWonAmount: PIXI.Text;
    private _youWonTitle: PIXI.Text;
    private _spinsPlayedTitle: PIXI.Text;
    //private _spinsPlayedAmount: PIXI.Text;
    private _spinsPlayedNoWinY: number;
    private _spinsPlayedHasWinY: any;
    private _bg: PIXI.Sprite;
    private _youWonSprite: PIXI.Sprite;

    private _totalGenieTitle: PIXI.Text;
    //private _totalGenieCount: PIXI.Text;

    private _gfxContainer: PIXI.Container;

    private _outroSpine: PIXI.spine.Spine;
    private _outroTimeline: TimelineLite;
    private _genieOutro: PIXI.Sprite;

    private _belowStakeWinnings: boolean = false; // #307

    protected _LastGenieMultiplier: number;


    constructor(config: IScreenViewConfig, autoClose?: boolean) {
        super(config, autoClose);
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.FREE_SPIN_OUTRO.name);

    }

    protected getScaledButtonTextStyle(): any {
        var style = this._config.buttonTextStyle ? this._config.buttonTextStyle : GuiDefaults.DEFAULT_LABEL_STYLE;
        if (!Number(style.fontSize)) {
            debugger;
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        if (SlotGame.api.options.device === 'desktop') {
            style.fontSize = (style.fontSize as any) + 12;
        } else {
            style.fontSize = (style.fontSize as any) * this._deviceScale;

        }
        return style;
    }

    protected addEventListeners(): void {
        super.addEventListeners && super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => {
            this.onGameDataParsed(event.params[0]);
        });
        // fixed #180 to show multiplier on outro,when restore on 2nd last spin.
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    /**
     * function to get multiplier value to show on outro,
     * info: on last spin multiplier is 1.
     * @param data
     */
    private onGameDataParsed(data: RomanEmpireParsedGameData | RomanEmpireParsedInitData): void {
        if (data.goldenGenieMultiplierNextSpin !== 1) {
            this._LastGenieMultiplier = data.goldenGenieMultiplierNextSpin;
        }

        // #307
       // this._belowStakeWinnings = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction) && (data as RomanEmpireParsedGameData).totalWin <= (data as RomanEmpireParsedGameData).playedBetValue;
        this._belowStakeWinnings = RomanEmpireGameModuleConfig.featurePrice.isWinBelowStake();
    }


    protected createGameGraphics(): PIXI.DisplayObject {
        this._gfxContainer = new PIXI.Container();
        this._genieOutro = new PIXI.Sprite(GameResources.getTextures("genieOutro")[0]);
        this._genieOutro.anchor.set(0.5);
        this._genieOutro.alpha = 0;
        this._genieOutro.scale.set(0.5);

        this._outroSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("introOutro"));
        let pos = Helper.getSymbolPositions(2, 1);
        this._outroSpine.position.set(pos[0] + 280, pos[1] - 25);
        this._outroSpine.visible = false;
        let x: number = GameConfig.instance.GAME_WIDTH * 0.5;
        const y: number = GameConfig.instance.GAME_HEIGHT / 2;
        let textStyle = {
            fontFamily: "Open Sans",
            fontSize: "52px",
            fontWeight: "bold",
            fill: [
                "#fedc45",
                "#ca8d19",
            ],
            fillGradientStops: [
                0.57,
                1
            ],
            dropShadowColor: "#000000",
            dropShadow: true,
            dropShadowAngle: 90,
            dropShadowDistance: 6,
            stroke: "#000000",
            strokeThickness: 1,
        };
        const wonTitleStyle = Object.assign({}, textStyle);
        wonTitleStyle.fontSize = "116px";
        this._bg = new PIXI.Sprite(GameResources.getTextures("FS_Background")[0]);
        this._bg.anchor.set(0.5, 0.5);
        this._youWonSprite = new PIXI.Sprite(GameResources.getTextures("youWonText")[0]);
        this._youWonSprite.anchor.set(0.5, 0.5);
        //this._bg.scale.set(1.5, 1.5);
        //this._bg.position.set(x,y);
        const wonAmtStyle = Object.assign({}, textStyle);
        wonAmtStyle.fontSize = "72px";
        this._youWonAmount = new PIXI.Text("0", wonAmtStyle);
        this._youWonAmount.anchor.set(0.5, 0.5);

        this._youWonTitle = new PIXI.Text(Translation.translate("You won"), wonTitleStyle);
        // textStyle.fill = ["#FFFFFF"];
        this._spinsPlayedTitle = new PIXI.Text(Translation.translate("Spins played") + ": ", textStyle);
        // textStyle.fill = ["#00FF8B", "#00E6FF", "#0064FF"];
        // textStyle.fillGradientStops = [0, 0.57, 1];

        this._totalGenieTitle = new PIXI.Text(Translation.translate("Golden Genie Multiplier:") + " ", textStyle);

        this._totalGenieTitle.anchor.set(0.5, 0.5);

        this._youWonTitle.anchor.set(0.5, 0.5);

        this._spinsPlayedTitle.anchor.set(0.5, 0.5);

        let youWonAmountHeight: number = this._youWonAmount.height;
        this._youWonTitle.y = y - youWonAmountHeight - 30;
        this._youWonSprite.y = y - youWonAmountHeight - 30;
        this._youWonAmount.y = y - youWonAmountHeight / 2;
        this._spinsPlayedNoWinY = y;
        this._spinsPlayedHasWinY = y + youWonAmountHeight / 2;

        this._totalGenieTitle.position.set(this._spinsPlayedTitle.x, this._youWonAmount.y + this._youWonAmount.height + 100);

        this._gfxContainer.addChild(this._bg, this._genieOutro, this._outroSpine);
        if (NolimitApplication.apiPlugin.options.language == "en") {
            this._gfxContainer.addChild(this._youWonSprite,);
        } else {
            this._gfxContainer.addChild(this._youWonTitle);
        }
        this._gfxContainer.addChild(this._youWonAmount, this._spinsPlayedTitle, this._totalGenieTitle);

        this._outroTimeline = new TimelineLite({
            paused: true, onComplete: () => {
                this.startOutroPresentation(this._gameData, this.onShowComplete);
            }
        });
        this._outroTimeline.add(new SpineTween(this._outroSpine, 0, "outro_animation"), 0);
        //this.shrinkTextWidth("", this._totalGenieTitle, 40);
        return this._gfxContainer;
    }

    private _gameData: RomanEmpireParsedGameData | undefined;
    private onShowComplete: any;

    /*
    * Dummy animation and text will replaced after graphics mock up finalized.
    * */
    protected startPresentation(data?: RomanEmpireParsedGameData, onShowComplete?: () => void): void {
        this._button.visible = false;
        this.onShowComplete = onShowComplete!();
        //this._spinsPlayedTitle.text = Translation.translate("Spins played:") + " " + data!.numberOfRespinPlayed;
        this._gameData = data;
        this.alpha = 0;
        this._totalGenieTitle.alpha = 0;
        this._youWonAmount.alpha = 0;
        this._youWonTitle.alpha = 0;
        this._youWonSprite.alpha = 0;
        this._spinsPlayedTitle.alpha = 0;
        this._gfxContainer.alpha = 1;

        this._outroTimeline.play(0);
        if (this._belowStakeWinnings) {
            this._outroTimeline.totalProgress(1); //#309
        }

        this.fadeFSBackgroundMusic();

        if (!this._belowStakeWinnings) {
            SoundManager.playFSOutro();
        }
        this._outroSpine.visible = true;
        TweenLite.to(this, 0.2, {
            alpha: 1, onComplete: () => {
                // added this event to change Background
                EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode: RomanEmpireGameMode.NORMAL}));
            }
        });

    }

    private fadeFSBackgroundMusic() {
        Logger.logDev("ReSpinSound fadeFSBackgroundMusic");
        SoundManager.fadeSound(RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS, 2000, 0);
        //TweenLite.delayedCall(2020,()=> this.stopAllFSSound());
    }

    private fadeInMainBackgroundMusic() {
        Logger.logDev("ReSpinSound fadeInMainBackgroundMusic");
        SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 2000, 1);
    }

    private startOutroPresentation(data?: RomanEmpireParsedGameData, onShowComplete?: () => void) {
        let delay: number = 0;

        const hasWin: boolean = true;//data!.totalWin > 0;
        const fs: number = 0.033;
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                super.startPresentation(data, onShowComplete);
                this._button.visible = true

            }
        });
        this._spinsPlayedTitle.text = Translation.translate("Spins played") + ": " + data!.numberOfRespinPlayed;
        this._totalGenieTitle.text = Translation.translate("Golden Genie Multiplier:") + " " + this._LastGenieMultiplier;
        this.resizeText();
        //this._spinsPlayedTitle.y = hasWin ? this._spinsPlayedHasWinY : this._spinsPlayedNoWinY;

        if (!hasWin) {
            tl.add([
                new TimelineLite().fromTo(this._spinsPlayedTitle, 5 * fs, {alpha: 0}, {alpha: 0})
                    .to(this._spinsPlayedTitle, 10 * fs, {alpha: 1}),
            ], 0);
        } else {
            this._youWonAmount.text = data!.totalWin.toFixed(2).toString();

            tl.add([
                new TimelineLite().fromTo(this._youWonAmount, 5 * fs, {alpha: 0}, {alpha: 0})
                    .to(this._youWonAmount, 10 * fs, {alpha: hasWin ? 1 : 0}),

                new TimelineLite().fromTo(this._youWonTitle, 5 * fs, {alpha: 0}, {alpha: 0})
                    .to(this._youWonTitle, 10 * fs, {alpha: (hasWin && !this._belowStakeWinnings) ? 1 : 0}),

                new TimelineLite().fromTo(this._youWonSprite, 5 * fs, {alpha: 0}, {alpha: 0})
                    .to(this._youWonSprite, 10 * fs, {alpha: (hasWin && !this._belowStakeWinnings) ? 1 : 0}),
                new TimelineLite().fromTo(this._spinsPlayedTitle, 5 * fs, {alpha: 0}, {alpha: 0})
                    .to(this._spinsPlayedTitle, 10 * fs, {alpha: 1}),

                new TimelineLite().fromTo(this._totalGenieTitle, 5 * fs, {alpha: 0}, {alpha: 0})
                    .to(this._totalGenieTitle, 10 * fs, {alpha: 1}),
                () => this.fadeInMainBackgroundMusic(),
                TweenLite.to(this._genieOutro, 10 * fs, {alpha: 1})
            ], delay);
        }
    }

    private resizeText() {
        this._totalGenieTitle.style.fontSize = 44;
        Utils.shrinkTextWidth("", this._totalGenieTitle, 610);
        this._youWonTitle.style.fontSize = 116;
        Utils.shrinkTextWidth("", this._youWonTitle, 610);
        this._spinsPlayedTitle.style.fontSize = 52;
        Utils.shrinkTextWidth("", this._spinsPlayedTitle, 610);
    }

    protected setButtonPosition(data: IResizeData): void {
        super.setButtonPosition(data);

        let buttonPosX = this._screenWidth * 0.5,
            buttonPosY = this._screenHeight * 0.89;

        if (data.orientation === Orientation.PORTRAIT) {
            // fix for 4:3 ratio
            if (data.height >= 950 && data.height <= 1000) {
                buttonPosY = this._screenHeight * 0.786;
            } else if (data.height >= 850 && data.height <= 900) {
                buttonPosY = this._screenHeight * 0.816;
            } else {
                buttonPosY = this._screenHeight * 0.85;
            }
        }
        //fix done for Continue button for Russian
        this._button.setSize(240, 82, 0.8);

        this._button.position.set(buttonPosX, buttonPosY);
    }

    protected stopPresentation(closeCallback?: () => void): void {
        this._outroSpine.visible = false;
        TweenLite.to(this._genieOutro, 0.3, {alpha: 0});
        RomanEmpireGameModuleConfig.featurePrice.reset();
        super.stopPresentation(closeCallback);
        // TweenLite.to(this._gfxContainer, 0.2, {alpha: 0, onComplete: () => super.stopPresentation(closeCallback)});
    }

    protected onResizeGameGraphics(resizeData: IResizeData): void {
        const middleX: number = resizeData.width * 0.5;
        const middleY: number = resizeData.height * 0.5;
        this._bg.position.set(middleX, middleY);
        this._youWonTitle.position.set(middleX, middleY - 80);
        this._youWonSprite.position.set(middleX, middleY - 80);
        this._youWonAmount.position.set(middleX, middleY + 50);
        this._spinsPlayedTitle.position.set(middleX, middleY + 130);
        this._totalGenieTitle.position.set(middleX, middleY + 200);
    }

    protected onResize(data: IResizeData): void {
        super.onResize(data);
        this._outroSpine.position.set(data.width / 2, data.height / 2);
        this._genieOutro.position.set(this._outroSpine.x - 650 * 0.5 - 110, data.height / 2);
        this._genieOutro.visible = (data.width * 0.5) > 530;
        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
    }

    protected onButtonClick(): void {
        SoundManager.playFSOutroContinue();
        super.onButtonClick();
    }
}
